import React, { useState, useEffect } from 'react';
import { Card, Button, List, Spin, message, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { visibleStore } from '../api/store';
import { useAtom } from "jotai";
import { storesAtom } from "../store/userAtom";
import request from '../utils/request';

const { Title } = Typography;

const ProductDetailPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { code } = location.state || {};
  const [productData, setProductData] = useState({});
  const [messageApi, contextHolder] = message.useMessage();
  const [stores, setStores] = useAtom(storesAtom);

  useEffect(() => {
    if (!code) {
      messageApi.error("没有找到商品编码");
      navigate('/');
      return;
    }

    // 初始化每个店铺的加载状态
    const initialProductData = {};
    stores.forEach(store => {
      initialProductData[store.store_id] = {
        storeId: store.store_id,
        storeName: store.store_name,
        loading: true,
        data: null,
        error: null
      };
    });
    setProductData(initialProductData);

    const fetchData = () => {
      stores.forEach(store => {
        // 使用项目封装的request.js发送请求
        const targetUrl = `${store.address}/get_articulo?code=${code}`;
        request.get('/proxy', {
          params: {
            address: encodeURIComponent(targetUrl)
          }
        })
          .then(response => {
            const data = response.data;
            setProductData(prev => ({
              ...prev,
              [store.store_id]: {
                ...prev[store.store_id],
                loading: false,
                data: data,
                error: null
              }
            }));
          })
          .catch(error => {
            console.error(`获取店铺 ${store.store_name} 商品信息失败:`, error);
            setProductData(prev => ({
              ...prev,
              [store.store_id]: {
                ...prev[store.store_id],
                loading: false,
                data: null,
                error: error
              }
            }));
          });
      });
    };

    fetchData();
  }, [code, navigate, messageApi, stores]);

  const handleBack = () => {
    navigate('/');
  };

  // 格式化数字为两位小数
  const formatNumber = (num) => {
    if (!num) return '0.00';
    return parseFloat(num).toFixed(2);
  };

  // if (loading) {
  //   return (
  //     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
  //       <Spin size="large" tip="正在加载商品信息..." />
  //     </div>
  //   );
  // }

  return (
    <div style={{ padding: '20px' }}>
      {contextHolder}
      
      {/* 返回按钮 */}
      <div style={{ marginBottom: '20px', textAlign: 'right' }}>
        <Button
          icon={<ArrowLeftOutlined />}
          onClick={handleBack}
        >
          返回
        </Button>
      </div>

      <Title level={2}>商品信息查询 (编码: {code})</Title>

      {stores?.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '50px' }}>暂无店铺数据</div>
      ) : (
        <List
          grid={{ gutter: 16, column: 1, xs: 1, sm: 2, md: 3, lg: 3, xl: 4, xxl: 4 }}
          dataSource={stores}
          renderItem={store => {
            const item = productData[store.store_id] || {};
            const productInfo = item?.data; // 获取嵌套的data对象
            return (
              <List.Item>
                <Card title={`店铺: ${item.storeName || store.store_name}`} bordered={true}>
                  {item.loading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                      <Spin size="small" tip="加载中..." />
                    </div>
                  ) : item.error ? (
                    <div style={{ color: '#f5222d', padding: '20px', textAlign: 'center' }}>
                      获取商品信息失败
                    </div>
                  ) : productInfo ? (
                    <div style={{ padding: '10px' }}>
                      <p><strong>名称:</strong> {productInfo.NombreES || '--'}</p>
                      <p><strong>售价:</strong> ¥{formatNumber(productInfo.PrecioDetalle)}</p>
                      <p><strong>编码:</strong> {productInfo.ArticuloID || '--'}</p>
                      <p><strong>条码:</strong> {productInfo.CodigoBarra || '--'}</p>
                      <p><strong>库存:</strong> {formatNumber(productInfo.StockDa)} 件</p>
                      <p><strong>进货价:</strong> ¥{formatNumber(productInfo.PrecioCoste)}</p>
                    </div>
                  ) : (
                    <div style={{ padding: '20px', textAlign: 'center' }}>
                      暂无商品信息
                    </div>
                  )}
                </Card>
              </List.Item>
            );
          }}
        />
      )}
    </div>
  );
};

export default ProductDetailPage;
